/** Zefix action error codes → i18n keys. Same shape as FIDUCIAIRE_ERROR_CODE_MAP. */
export const ZEFIX_ERROR_CODE_MAP = {
  ZEFIX_RATE_LIMITED: 'zefix:errors.rateLimited',
  ZEFIX_NOT_FOUND: 'zefix:errors.notFound',
  ZEFIX_UNAVAILABLE: 'zefix:errors.unavailable',
} as const;

/**
 * The i18n key for a thrown Zefix error, or null when it is not one of ours.
 * The widget renders these INLINE rather than through `handleMutationError`:
 * it also runs on the auth screens, which mount no `<Toaster />`.
 */
export function zefixErrorKey(err: unknown): string | null {
  const message = err instanceof Error ? err.message : String(err);
  for (const [code, key] of Object.entries(ZEFIX_ERROR_CODE_MAP)) {
    if (message.includes(code)) return key;
  }
  return null;
}
